import { useEffect } from 'react';
import { installContentProtection } from '../utils/contentProtection';

export function useContentProtection({ enabled = false, onViolation } = {}) {
    useEffect(() => {
        if (!enabled) return undefined;
        return installContentProtection({ onViolation });
    }, [enabled, onViolation]);
}
